import {IsInt, IsString, MaxLength} from 'class-validator';
import {GROUP_NAME_MAX_LENGTH_API} from '../constants/contacts-api.constants';

export class CreateContactGroupRequestDto {
  @IsString()
  @MaxLength(GROUP_NAME_MAX_LENGTH_API)
  name!: string;

  @IsInt()
  context!: number;
}
